import script from "./TwoClickButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoClickButton.vue?vue&type=script&setup=true&lang=js"

import "./TwoClickButton.vue?vue&type=style&index=0&id=d67ae408&scoped=true&lang=css"

import exportComponent from "/home/runner/work/prayerwall/prayerwall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d67ae408"]])

export default __exports__